<template>
  <div class="medical-portal-index">
    <header class="hero">
      <h1>医疗门户</h1>
      <p>选择要查看的模块</p>
    </header>

    <main class="card-grid">
      <router-link class="portal-card" to="/all-category">
        <h2>全部分类</h2>
        <p>查看疾病、药品与分类目录。</p>
      </router-link>

      <router-link class="portal-card" to="/disease-detail">
        <h2>疾病详情</h2>
        <p>查看疾病概览、症状与推荐用药。</p>
      </router-link>

      <router-link class="portal-card" to="/drug-detail">
        <h2>药品详情</h2>
        <p>查看药品说明、注意事项与关联信息。</p>
      </router-link>
    </main>
  </div>
</template>

<script>
export default {
  name: "MedicalPortalIndex",
};
</script>

<style scoped>
.medical-portal-index {
  min-height: 100vh;
  padding: 28px 16px 36px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef7ff 100%);
}

.hero {
  max-width: 980px;
  margin: 0 auto 20px;
  padding: 20px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.08);
}

.hero h1 {
  margin: 0;
  font-size: 28px;
  color: #0f172a;
}

.hero p {
  margin: 10px 0 0;
  color: #475569;
}

.card-grid {
  max-width: 980px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.portal-card {
  display: block;
  padding: 18px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  text-decoration: none;
  transition: all 0.2s ease;
}

.portal-card h2 {
  margin: 0;
  color: #0f172a;
  font-size: 18px;
}

.portal-card p {
  margin: 10px 0 0;
  color: #64748b;
  line-height: 1.7;
  font-size: 14px;
}

.portal-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08);
}

@media (max-width: 900px) {
  .card-grid {
    grid-template-columns: 1fr;
  }
}
</style>
